import React, { useContext, useMemo } from 'react'
import { DataContext } from './DataContext'
import { PanelStyleContext } from '../../../elem/panel/PanelStyleContext'
import { UserContext } from '../../../wrappers/UserContext'
import { isReviewerRole } from '../../../../utils/user/permissions'

const DetailTabs = () => {
    const { visibleTab, setVisibleTab } = useContext(DataContext)
    const { tabClass } = useContext(PanelStyleContext)
    const { roles } = useContext(UserContext)
    const isReviewer = useMemo(() => isReviewerRole(roles), [roles])
    return (
        <div className={`tabs is-small is-boxed is-fullwidth ${tabClass}`}>
            <ul>
                <li
                    className={visibleTab === 'well' ? 'is-active' : ''}
                    onClick={() => setVisibleTab('well')}
                >
                    <div>
                        <span>Well Details</span>
                    </div>
                </li>
                <li
                    className={visibleTab === 'screens' ? 'is-active' : ''}
                    onClick={() => setVisibleTab('screens')}
                >
                    <div>
                        <span>Well Screens</span>
                    </div>
                </li>
                <li
                    className={visibleTab === 'samples' ? 'is-active' : ''}
                    onClick={() => setVisibleTab('samples')}
                >
                    <div>
                        <span>Sample Results</span>
                    </div>
                </li>
                {isReviewer && (
                    <li
                        className={visibleTab === 'wellTypeHistory' ? 'is-active' : ''}
                        onClick={() => setVisibleTab('wellTypeHistory')}
                    >
                        <div>
                            <span>Well Type History</span>
                        </div>
                    </li>
                )}
            </ul>
        </div>
    )
}

export default DetailTabs
